import React from "react";
import { FEEDLIST_COLUMN_IDS } from "../../../../../modules/stringConstants";
import { IconButton } from "@toddle-edu/ds-web";
import { ChevronRightOutlined } from "@toddle-edu/ds-icons";

const styles = {
  navigatorButton: {
    margin: "0 auto",
  },
};

const FeedButton = props => {
  const { column, id, testId } = props;

  const { id: columnId } = column;

  switch (columnId) {
    case FEEDLIST_COLUMN_IDS.NAVIGATOR:
      return (
        <IconButton
          icon={<ChevronRightOutlined variant="subtle" />}
          type="plain"
          variant="neutral"
          testId={`${testId}-${columnId}-${id}-view`}
          style={styles.navigatorButton}
        />
      );
    default:
      return null;
  }
};

export default FeedButton;
